import createReactComponent from '../createReactComponent';
export default createReactComponent('sticker', 'IconSticker', [
  ['path', { d: 'M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8', key: 'svg-0' }],
  ['path', { d: 'M20 12a8 8 0 1 1 -8 -8', key: 'svg-1' }],
]);
